import {
  SelectInput,
  SelectInputEventValue
} from "@interstate/components/SelectInput";
import { useEffect, useState } from "react";
import { usePhoneReply } from "../context";
import {
  ContactEnum,
  EventResultEnum
} from "@coxauto-ui/cxm/communications/interfaces";
import { replyCallContactedDropDownTestId } from "../testIds";
import { InterstateOnChangeEvent } from "@interstate/components/InterstateEvents";

/* eslint-disable-next-line */
export interface MessageCallContactedInputProps {}

export function MessageCallContactedInput(
  props: MessageCallContactedInputProps
) {
  const [callContacted, setCallContacted] = useState(
    ContactEnum.MACHINE_ANSWERED.toString()
  );
  const { messageCallContacted, setMessageCallContacted } = usePhoneReply();
  const onSelectedInputChange = (
    iEvent: InterstateOnChangeEvent<SelectInputEventValue>
  ) => {
    const changeVal = iEvent.target.value?.toString();
    if (changeVal === undefined) return;
    setCallContacted(changeVal);
    setMessageCallContacted(changeVal);
  };
  useEffect(() => {
    if (callContacted !== messageCallContacted)
      setMessageCallContacted(callContacted);
  }, [callContacted, messageCallContacted, setMessageCallContacted]);
  return (
    <SelectInput
      required
      data-testid={replyCallContactedDropDownTestId}
      displayDeselectOption={false}
      id="messageCallContactedInput"
      label="Contacted"
      name="CallContacted"
      options={[
        {
          label: EventResultEnum.SPOKE,
          value: ContactEnum.YES.toString()
        },
        {
          label: EventResultEnum.NOANSWER,
          value: ContactEnum.NO.toString()
        },
        {
          label: EventResultEnum.LEFTMESSAGE,
          value: ContactEnum.MACHINE_ANSWERED.toString()
        }
      ]}
      value={callContacted}
      onChange={onSelectedInputChange}
    />
  );
}

export default MessageCallContactedInput;
